// extracted by mini-css-extract-plugin
export var block = "styles-module--block--CI-6O";